import { render, staticRenderFns } from "./slide-title.vue?vue&type=template&id=072f7190"
import script from "./slide-title.vue?vue&type=script&lang=js"
export * from "./slide-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports